import HelpSmall from '@/icons/help-small';
import { Button, ButtonProps } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { forwardRef } from 'react';

interface PDPPlanInfoModalTriggerProps extends ButtonProps {
  description?: string;
  helpSmallClassName?: string;
  PRISTINE_HERO_PDP?: boolean;
}

const PDPPlanInfoModalTrigger = forwardRef<
  HTMLButtonElement,
  PDPPlanInfoModalTriggerProps
>(
  (
    {
      description,
      helpSmallClassName,
      className,
      disabled,
      PRISTINE_HERO_PDP = false,
      ...props
    }: PDPPlanInfoModalTriggerProps,
    ref
  ) => {
    return (
      <Button
        variant="clear"
        type="button"
        className={cn('h-fit', className)}
        ref={ref}
        disabled={disabled}
        {...props}
      >
        <div className="flex items-center">
          <p className="body2-strong text-flexcar-neutral1">{description}</p>
          <HelpSmall
            fillPrimary={disabled ? colors.neutral60 : colors.neutral1}
            {...(PRISTINE_HERO_PDP
              ? {
                  hoverFillPrimary: disabled
                    ? 'group-hover:fill-flexcar-neutral60'
                    : 'group-hover:fill-flexcar-blue50',
                }
              : {})}
            className={cn('transition-all', helpSmallClassName)}
          />
        </div>
      </Button>
    );
  }
);

PDPPlanInfoModalTrigger.displayName = 'PDPPlanInfoModalTrigger';

export default PDPPlanInfoModalTrigger;
